import styled from 'styled-components';

import Text from '../../Text';

export const EmbroideryLine = styled(Text).attrs({
  variant: 'miniCartQuality',
})`
  font-size: 12px;
  font-weight: 400;
`;

export const DetailText = styled.span`
  color: ${({ theme }) => theme.colors.textDefault};
`;

export const CustomizationText = styled.span`
  color: ${({ theme }) => theme.colors.textDefault};
`;
